import { ErrorHandler, inject } from "@angular/core";
import { Router } from "@angular/router";
import { LocalRepository } from "@shared/helper/local-repository";
import { JL } from 'jsnlog';

export class ExceptionLogger implements ErrorHandler {

    router = inject(Router);
    repo = inject(LocalRepository);

    handleError(error: any): void {
            console.log(error)

        if (this.repo.IsInBrowser){
            JL().error({ agent: window.navigator.userAgent, path: this.router.routerState.snapshot.url, applicationContext: 'Web-Client', error_desscription: String(error) });
        }
        else {
            console.log(error)
        }
        // throw error;
    }
}